// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { TransactionForm } from '@client/banks/components/shared/transaction-form';
import { NavigationControls } from '@client/banks/layouts/navigation-controls';
import { ScreenLayout } from '@client/banks/layouts/screen-layout';
import { Translation } from '@shared/ui-kit/providers/translation-provider/translation';
import { defineComponent } from '@shared/ui-kit/utils/define-component';
import { FormProvider } from 'react-hook-form';
import catalogStyles from '../styles/institution-catalog.module.css';
import { useTransactionsForm } from './use-transactions-form';

export const TransactionsFormStep = defineComponent({
  displayName: 'TransactionsFormStep',
  useSetup: useTransactionsForm,
  View: ({
    form,
    currencyOptions,
    accountIbanOptions,
    defaultCurrency,
    linkedLiquidityApiRef,
    onLinkedLiquidityGateChange,
    isFormValid,
    onSubmit,
    onCancel,
  }) => (
    <FormProvider {...form}>
      <ScreenLayout
        className="!pt-6"
        actions={
          <NavigationControls
            form="transactions-form"
            isFormValid={isFormValid}
            nextLabel={<Translation i18nKey="common.save" ns="common" />}
            nextStep="transactions-list"
            onPrevious={onCancel}
            previousLabel={<Translation i18nKey="common.cancel" ns="common" />}
            previousStep="transactions-list"
          />
        }
      >
        <div className={catalogStyles['step-body']}>
          <TransactionForm
            formId="transactions-form"
            onSubmit={onSubmit}
            currencyOptions={currencyOptions}
            accountIbanOptions={accountIbanOptions}
            defaultCurrency={defaultCurrency}
            linkedLiquidityApiRef={linkedLiquidityApiRef}
            onLinkedLiquidityGateChange={onLinkedLiquidityGateChange}
          />
        </div>
      </ScreenLayout>
    </FormProvider>
  ),
});
